import { Children } from 'react';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPDependentsList = ({
  children,
  disabledMessage,
  disableLinks,
  title
}) => {
  return /*#__PURE__*/_jsxs(ExpandableSection, {
    titleText: title,
    children: [disableLinks && disabledMessage && /*#__PURE__*/_jsx(Alert, {
      type: "info",
      marginBlockEnd: "500",
      children: disabledMessage
    }), /*#__PURE__*/_jsx(List, {
      styled: true,
      children: Children.map(children, child => {
        return /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: child
        });
      })
    })]
  });
};
export default EPDependentsList;